import { fork } from 'redux-saga/effects';
import { appSagas } from "../app/appSagas";
import { accountSagas } from "../modules/Account/accountSagas";
import { bonusesSagas } from "../modules/Bonus/bonusesSagas";
import { googleTagManagerSagas } from "../modules/GoogleTagManager/googleTagManagerSagas";
import { liteTradeSagas } from "../modules/LiteTrade/liteTradeSagas";
import { loginSagas } from "../modules/Login/loginSagas";
import { notificationsSagas } from "../modules/Notifications/notificationsSagas";
import { mobileAppSagas } from "./mobileAppSagas";
import { depositSagas } from "../modules/Deposit/depositSagas";
import { settingsSagas } from "../modules/Settings/settingsSagas";
import { achievementsSagas } from "../modules/Achievements/achievementsSagas";
import { internetConnectionSagas } from "../modules/InternetConnection/internetConnectionSagas";
import { withdrawalSagas } from "../modules/Withdrawal/withdrawalSagas";
import { websocketSagas } from '../providers/WebSocketProvider/sagas/websocketSagas';
import { tutorialsSagas } from "../modules/Tutorials/tutorialsSaga";
import { userSagas } from "../app/userSaga";
import { pwaSagas } from "../modules/Pwa/pwaSagas";
import { locationSagas } from "../modules/Location/locationSagas";
import { bannersSagas } from "../modules/Banners/bannersSagas";
import { assetTabsSagas } from "../modules/AssetTabs/assetTabsSagas";
import { alertsSagas } from "../modules/Alerts/alertsSagas";
import { userHintsSagas } from "../modules/UserHints/userHintsSaga";
import { colorThemeSagas } from "../modules/ColorTheme/colorThemeSaga";
import { referralSagas } from "../modules/Referral/referralSaga";
import { demoLimitsSagas } from "../modules/DemoLimits/demoLimitsSaga";
import { academySagas } from "../modules/Academy/academySagas";
import { leaderboardSagas } from "../modules/Leaderboard/leaderboardSagas";

export function* mobileAppCoreSagas() {
    yield fork(academySagas);
    yield fork(accountSagas);
    yield fork(achievementsSagas);
    yield fork(alertsSagas);
    yield fork(appSagas);
    yield fork(assetTabsSagas);
    yield fork(bannersSagas);
    yield fork(bonusesSagas);
    yield fork(depositSagas);
    yield fork(demoLimitsSagas);
    yield fork(googleTagManagerSagas);
    yield fork(internetConnectionSagas);
    yield fork(liteTradeSagas);
    yield fork(locationSagas);
    yield fork(loginSagas);
    yield fork(leaderboardSagas);
    yield fork(mobileAppSagas);
    yield fork(notificationsSagas);
    yield fork(pwaSagas);
    yield fork(referralSagas);
    yield fork(settingsSagas);
    yield fork(colorThemeSagas);
    yield fork(tutorialsSagas);
    yield fork(websocketSagas);
    yield fork(withdrawalSagas);
    yield fork(userSagas);
    yield fork(userHintsSagas);
}
